import React, { useState } from 'react';
import { View, Text, StyleSheet } from 'react-native';

import {
  downloadReport,
  DownloadButton
} from '../../elements/ReportDownload';
import SearchableSelect from 'app/src/elements/SearchableSelect';
import { sellerOptions, saleOptions } from './filterOptions';

import { cardStyles as styles } from './index';

const BlockReport = ({ data }) => {
  const [saleId, setSaleId] = useState(null);
  const [sellerId, setSellerId] = useState();

  const handleDownload = downloadProps => {
    downloadReport({
      ...downloadProps,
      path: 'block-report',
      params: { 'sale-id': saleId, 'seller-id': sellerId }
    });
  };

  return (
    <View style={styles.container}>
      <Text style={styles.title}>Block Report</Text>
      <Text style={styles.label}>Sale:</Text>
      <SearchableSelect
        placeholder="Select Sale"
        options={saleOptions(data)}
        value={saleId}
        onChange={setSaleId}
      />
      <Text style={styles.label}>Seller (optional):</Text>
      <SearchableSelect
        placeholder="Select Seller"
        options={sellerOptions(data)}
        value={sellerId}
        onChange={setSellerId}
      />
      <DownloadButton handleDownload={handleDownload} />
    </View>
  );
};

export default BlockReport;
